import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import { slideFragment } from '@schema/slide'
import MemberEventsLanding from './index'
import { MEMBER_FEATURED_STORIES_QUERY } from './member-events-landing.fragment'

const QUERY = gql`
query MemberEventsLandingPage($preview: Boolean)  {
  memberEventsLandingCollection(limit: 1, preview: $preview)  {
    items {
      headline
      heroImage {
        url
      }
      featuredEvent {
        __typename
        headline
        startDate
        endDate
        slug
        image {
          url
        }
      }
      eventCategoriesCollection {
        total
        items {
          sys {
            id
          }
          title
          name
        }
      }
      ctaBoxesCollection(limit: 2) {
        items {
          ${slideFragment}
        }
      }
      metaTitle
      metaDescription
      metaImage {
        url
      }
    }
  }
}
`

export { QUERY as MEMBER_EVENTS_LANDING_QUERY }

export default function MemberEventsLandingWithData(props) {
  const { query, ssrData } = props

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    return ssrData ? (
      <MemberEventsLanding
        eventGridHeadline="Member Programs"
        parentCollection="memberEventsLandingCollection"
        featuredStoriesQuery={MEMBER_FEATURED_STORIES_QUERY}
        {...ssrData}
        {...props}
      />
    ) : <Error statusCode={404} />
  }

  // Fallback to client-side fetching
  return (
    <Query query={QUERY} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} displayErrorType="page" />
        if (loading) return <LinearProgress color="secondary" />

        const response = data.memberEventsLandingCollection
          && data.memberEventsLandingCollection.items[0]

        return response ? (
          <MemberEventsLanding
            eventGridHeadline="Member Programs"
            parentCollection="memberEventsLandingCollection"
            featuredStoriesQuery={MEMBER_FEATURED_STORIES_QUERY}
            {...response}
            {...props}
          />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

MemberEventsLandingWithData.propTypes = {
  query: PropTypes.object,
  ssrData: PropTypes.object,
}
